
export const PCODE_STATE_STOPPED = '***';
export const PCODE_STATE_RUN = '*R*';
export const PCODE_STATE_PAUSED = '**B';
export const PCODE_STATE_DEBUG_PRINT_AND_STOP = '**P';
export const PCODE_STATE_ERROR = 'C**';
export const PCODE_STATE_DEBUG_PRINT_AND_CONTINUE = '*P*';
export const PCODE_STATE_HALT = '05';
export const PCODE_STATE_STACK_OVERFLOW = '06';
export const PCODE_STATE_OOR = '0A';
export const PCODE_STATE_DIVIDE_BY_ZERO = '02';
export const PCODE_STATE_ILLEGAL_OPCODE = '03';
